import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import DataContainer from 'Components/UI/DataContainer';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';

import BestNextStep from './BestNextStep';

const styles = theme => ({
  container: {}, // This style is only applied to the DataContainer
  root: {
    padding: theme.spacing(2),
  },
});

const BestNextStepContainer = ({
  className,
  classes,
}) => {
  const { householdResource } = useSimpleHousehold();

  return (
    <DataContainer
      className={classes.container}
      component={BestNextStep}
      componentProps={{
        className: classNames(classes.root, className),
        householdResource,
      }}
      loading={!householdResource}
    />
  );
};

BestNextStepContainer.defaultProps = {
  className: '',
};

BestNextStepContainer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(BestNextStepContainer);
